import React from "react";
import { ContentURL, getContentUrl } from "../Utils/ContentURL";
import { BookingFlowTriggerSource } from "../UILogicControl/UILogicControlEntities";

/** UI elements that displays above the inline credit card input fields in the booking form. */
export const CreditCardFormHeader: React.FC<{ BookingTrigger: BookingFlowTriggerSource }> = (props) => {
    return (
        <div className="card-images">
            {props.BookingTrigger === BookingFlowTriggerSource.TrackingSms && <span className="we-accept">We accept</span>}
            {
                CardTypes.map((type, index) => {
                    return <img src={getContentUrl(ContentURL.images.PaymentType.Selector[type])} key={index} alt={type + " icon"}></img>
                })
            }
        </div>
    );
}

const CardTypes = [
    "Visa",
    "Mastercard",
    "AmericanExpress",
    "Discover",
] as const;